import { trans } from "@mongez/localization";
import { cn } from "core/shared";
import emptyCart from "~/assets/images/empty/cart.png";
import { BaseLink } from "~/design-system/components";
import { URLS } from "~/shared/urls";

type EmptyCartProps = {
  className?: string;
};

export function EmptyCart({ className }: EmptyCartProps) {
  return (
    <div
      className={cn(
        "flex h-[700px] w-full items-center justify-center bg-[#f7f7f7]",
        className,
      )}
    >
      <div className="container flex max-w-full flex-col items-center gap-6 sm:max-w-[430px]">
        <img src={emptyCart} alt="empty cart" />
        <h2 className="font-playfair text-base font-bold text-[#0A0A0A] sm:text-lg lg:text-xl">
          {trans("cart.emptyTitle")}
        </h2>
        <p className="font-avenir text-center text-sm font-medium text-[#414141]/50 sm:text-base lg:text-lg">
          {trans("cart.emptySubtitle")}
        </p>

        <BaseLink
          to={URLS.ourCakes.list}
          className="bg-primary-light hover:bg-primary-600 mt-6 h-auto justify-center rounded-full border border-black px-4 py-4 transition-colors duration-300"
        >
          {trans("continueShopping")}
        </BaseLink>
      </div>
    </div>
  );
}
